import { Injectable } from '@angular/core';
import { UserFilter } from '@shared/entities/userFilter';
import { ApiService } from './api.service';
import { BehaviorSubject, Observable, shareReplay, Subject, switchMap, take, tap } from 'rxjs';
import { UserFilterURL } from './user.service';
import { ActivatedRoute } from '@angular/router';

const LOG_PREFIX = '[Api][UserFilters] ';

export interface MachineFilterURL {
  role?: string;
  locationId?: string;
  direction?: 'ASC' | 'DESC';
}
@Injectable({
  providedIn: 'root'
})
export class UserFiltersService extends ApiService<UserFilter> {
  private _refresh$: Subject<boolean>;
  all$: Observable<UserFilter>;
  currentFilters: MachineFilterURL = {};

  set filters(value: UserFilterURL) {
    this.currentFilters = value;
    this.refresh(true);
  }

  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/users/filters';
    const detailUrl = '/users/filters';

    super(UserFilter, masterUrl, detailUrl);

    this._refresh$ = new BehaviorSubject<boolean>(true);

    this.all$ = this._refresh$.pipe(
      switchMap(() => {
        const { locationId } = this.activatedRoute.snapshot.queryParams;
        if (locationId) {
          this.setUrlParameter('locationId', locationId);
        }
        if (this.currentFilters.role) {
          this.setUrlParameter('role', this.currentFilters.role);
        }
        return this.findOne('');
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err)
      }),
      shareReplay(1)
    );
  }

  refresh(value: boolean) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this._refresh$.next(value);

    return this.all$.pipe(take(1));
  }
}
